import {match} from 'ts-pattern';

import {HEADER_CELL_BORDER_BOTTOM} from '../../../../constants/borderStyles';
import {SELECTION_COLUMN_WIDTH} from '../../../../constants/selectionColumn';
import {SelectAllCheckbox} from '../SelectAllCheckbox/SelectAllCheckbox';

type SelectionHeaderCellProps = {
  rowSelectMode: 'SINGLE' | 'MULTIPLE' | 'NONE';
  /** Sticky top offset in px — matches the rest of the header row. */
  stickyTop: number;
};

/**
 * The leading checkbox pseudo-column header cell: SelectAllCheckbox for MULTIPLE
 * selection, an empty sticky placeholder <th> for SINGLE, and nothing for NONE.
 */
export function SelectionHeaderCell(props: SelectionHeaderCellProps) {
  return match(props.rowSelectMode)
    .with('MULTIPLE', () => <SelectAllCheckbox stickyTop={props.stickyTop} />)
    .with('SINGLE', () => (
      <th
        className="p-0 bg-white"
        style={{
          width: SELECTION_COLUMN_WIDTH,
          position: 'sticky',
          top: props.stickyTop,
          left: 0,
          zIndex: 'var(--z-content-loader)',
          ...HEADER_CELL_BORDER_BOTTOM,
        }}
      />
    ))
    .with('NONE', () => null)
    .exhaustive();
}
